import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";
const { speedUpextractList, speedUpCheck } = httpApi.moneyTx;

// 极速提现异常列表
interface SpeedUpextractListParams {
  account: string;
  extract_type: number | string;
  page: number;
  pagenum: number;
  type: number;
  uid: string;
}

export const apiSpeedUpextractList = (json: SpeedUpextractListParams): any =>
  http.httpPost({
    url: speedUpextractList,
    json,
  });

// 极速提现异常审核
interface SpeedUpCheckParams {
  id_arr: number[];
  type: number;
  tips: string;
}

export const apiSpeedUpCheck = (json: SpeedUpCheckParams): any =>
  http.httpPost({
    url: speedUpCheck,
    json,
  });
